import React from 'react';

export default function ExcelExport({ ...rest }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6 3H18C19.6569 3 21 4.34315 21 6V14.7178C21 14.9377 20.9273 15.1507 20.7949 15.3242L20.7344 15.3965L15.8594 20.6787C15.6701 20.8837 15.4031 21 15.124 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3Z"
        stroke="#00528A"
        strokeWidth="2"
      />
      <path
        d="M22 14H18C15.7909 14 14 15.7909 14 18V22"
        stroke="#00528A"
        strokeWidth="2"
      />
      <path
        d="M13.8413 7.52083C14.3162 6.89751 13.8717 6 13.088 6V6C12.7925 6 12.5139 6.13798 12.3348 6.37305L6.15873 14.4792C5.68381 15.1025 6.12832 16 6.91196 16V16C7.20749 16 7.48608 15.862 7.66518 15.6269L13.8413 7.52083Z"
        fill="#00528A"
      />
      <path
        d="M6.2853 7.58191C5.77017 6.9479 6.22135 6 7.03824 6V6C7.33038 6 7.60696 6.13165 7.79118 6.35838L12.7147 12.4181C13.2298 13.0521 12.7787 14 11.9618 14V14C11.6696 14 11.393 13.8684 11.2088 13.6416L6.2853 7.58191Z"
        fill="#00528A"
      />
    </svg>
  );
}
